import { render, staticRenderFns } from "./ProductOrders.vue?vue&type=template&id=25b0e7fb"
import script from "./ProductOrders.vue?vue&type=script&lang=js"
export * from "./ProductOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports